import { EnvironmentConfig } from './environment-config';

const apiEndpoint = API_ENDPOINT || 'https://api.dev.projectprocure-online-quotation.hitachienergy.com/api/';
const instrumentationKey = APPINSIGHTS_INSTRUMENTATIONKEY || '';

/**
 * This is the environment configuration for the 'develop' context of the project.
 *
 * The following contexts or environments are available:
 *  - development (environment.ts): For local development.
 *  - develop (environment.develop.ts): First deploy after merges. Development built for production.
 *  - staging (environment.staging.ts): Staging environment before production (acceptance tests).
 *  - production (environment.production.ts): Final stage for live application.
 */
export const environment: EnvironmentConfig = {
  production: true,
  title: 'Development',
  isEnvironmentBannerEnabled: true,
  displayBetaBannerIfEnabled: false,
  apiEndpoint,
  instrumentationKey,
};
